import { Grid } from '@mui/material';
import { DraftCardMediaContainer } from '../draft-card-media-container/draft-card-media-container';
import { getImageBySize } from 'utils/helpers';
import { styles } from './styles';

export interface IDraftCardImage {
  src: string;
  alt: string;
}

export const DraftCardImage = ({ src, alt }: IDraftCardImage) => {
  return (
    <DraftCardMediaContainer>
      <Grid
        sx={styles.image}
        component="img"
        src={getImageBySize(src, 86, 66, false, true)}
        alt={alt}
      />
    </DraftCardMediaContainer>
  );
};
